import React from 'react';
import { Messages, MessagesMessage } from 'primereact/messages';
import { Toast, ToastSeverityType } from 'primereact/toast';

export interface ToastMessage {
  severity?: ToastSeverityType;
  summary?: React.ReactNode;
  detail?: React.ReactNode;
  content?: React.ReactNode;
  closable?: boolean;
  sticky?: boolean;
  life?: number;
  className?: string;
  style?: Record<string, unknown>;
  contentClassName?: string;
  contentStyle?: Record<string, unknown>;
}

function getErrorDetail(error: any): string {
  if (typeof error.message === 'string') {
    return error.message.replace('[GraphQL]', '');
  }
  if (typeof error === 'string') {
    return error.replace('[GraphQL]', '');
  }
  return '';
}

export function showErrorMessage(
  messageComponent: Messages | null,
  error: any,
  overrides?: MessagesMessage,
): void {
  messageComponent?.show({
    sticky: true,
    severity: 'error',
    detail: getErrorDetail(error),
    ...overrides,
  });
}

export function showErrorToast(
  toastComponent: Toast | null,
  error: any,
  overrides?: ToastMessage,
) {
  toastComponent?.show({
    severity: 'error',
    summary: 'Error',
    detail: getErrorDetail(error),
    contentClassName: '',
    ...overrides,
  });
}
